// Shared, pure preference rules: the API and browser use the same limits.
export const CLAIM_PANEL_MIN_WIDTH = 224;
export const CLAIM_PANEL_MAX_WIDTH = 480;
export const CLAIM_PANEL_DEFAULTS = Object.freeze({ pinned: false, width: CLAIM_PANEL_MIN_WIDTH });

export function normalizeClaimPanelPreferences(input) {
  return {
    pinned: typeof input?.pinned === "boolean" ? input.pinned : false,
    width: typeof input?.width === "number" && Number.isFinite(input.width)
      ? Math.max(CLAIM_PANEL_MIN_WIDTH, Math.min(CLAIM_PANEL_MAX_WIDTH, Math.round(input.width)))
      : CLAIM_PANEL_DEFAULTS.width,
  };
}
